import * as PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Marker as GoogleMapMarker, InfoWindow as GoogleMapInfoWindow } from 'react-google-maps';

import blueDot from 'assets/images/blue-dot.png';
import redDot from 'assets/images/red-dot.png';

import { MarkerTypes } from '../../services/constants';

const Marker = ({ title, type, position, link, onDragEnd, openInfoWindow, onClick, onCloseClick }) => (
    <GoogleMapMarker
        onClick={onClick}
        onDragEnd={onDragEnd}
        draggable={type === MarkerTypes.PIN}
        position={position}
        icon={{ url: type === MarkerTypes.PIN ? redDot : blueDot }}
    >
        {title && openInfoWindow && (
            <GoogleMapInfoWindow onCloseClick={onCloseClick}>
                <>
                    {type === MarkerTypes.PIN && (
                        <Link to={link}>
                            <strong>{title}</strong>
                        </Link>
                    )}
                    {type !== MarkerTypes.PIN && <strong>{title}</strong>}
                </>
            </GoogleMapInfoWindow>
        )}
    </GoogleMapMarker>
);

Marker.propTypes = {
    title: PropTypes.string,
    type: PropTypes.oneOf(Object.values(MarkerTypes)).isRequired,
    position: PropTypes.shape({
        lat: PropTypes.number.isRequired,
        lng: PropTypes.number.isRequired,
    }).isRequired,
    link: PropTypes.string,
    onDragEnd: PropTypes.func.isRequired,
    openInfoWindow: PropTypes.bool,
    onClick: PropTypes.func,
    onCloseClick: PropTypes.func,
};

Marker.defaultProps = {
    title: null,
    link: null,
    openInfoWindow: false,
    onClick: () => {},
    onCloseClick: () => {},
};

export default Marker;
